import { render, staticRenderFns } from "./payroll-remittances.vue?vue&type=template&id=14ba2d4e"
import script from "./payroll-remittances.vue?vue&type=script&lang=js"
export * from "./payroll-remittances.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports